module.exports = __webpack_public_path__ + "static/img/zhuan1.adb32fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/zhuan1.png
// module id = yYnb
// module chunks = 1